module.exports = __webpack_public_path__ + "img/noWechatBind.b1769780.png";